import { createContext } from 'react';
import { Metrics } from '../metrics';

/**
 * The context for the MetricsProvider.
 */

export type MetricsContextType = {
  metrics: Metrics;
};

export const MetricsContext = createContext<MetricsContextType | undefined>(
  undefined
);
